import { render } from "./Survey.vue?vue&type=template&id=6ecf2012&ts=true"
import script from "./Survey.vue?vue&type=script&lang=ts"
export * from "./Survey.vue?vue&type=script&lang=ts"

import "./Survey.vue?vue&type=style&index=0&id=6ecf2012&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/HeThongPVNB/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__